/* eslint-disable */
import React from "react";

const Footer = () => {
  return (
    <div className="flex w-full flex-col items-center justify-between px-1 pb-6 pt-3 lg:px-8 xl:flex-row">
      <p className="mb-3 text-center text-[11px] text-gray-400 sm:!mb-0">
        © {new Date().getFullYear()} CORE Professional. All Rights Reserved.
      </p>
      <ul className="flex flex-wrap items-center gap-6">
        {["Support Center", "HR Policy", "Terms of Use"].map((item) => (
          <li key={item}>
            <a href="#" className="text-[11px] text-gray-400 transition-colors hover:text-[#0055FF]">
              {item}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Footer;